import {ShortScore} from './ShortScore';
export default ShortScore;